import { fetchOTIF } from './otifSlice';
import { fetchCoq } from './coqSlice';
import { fetchRemakes } from './remakeslice';
import { fetchBacklog } from './backlogSlice';
import { fetchBit } from './bitSlice';
import { fetchShelled } from './shelledSlice';
import { fetchTotals } from './totalsSlice';
import { fetchDisputes } from './disputeSlice';
import { fetchOtherIssues } from './otherIssues';
import { fetchStillage } from './stillages';
import { fetchCoqYear } from './coqYearSlice';

export const fetchAllTiles = (filters) => (dispatch) => {
    const requests = [
        dispatch(fetchOTIF(filters)),
        dispatch(fetchCoq(filters)),
        dispatch(fetchCoqYear(filters)),
        dispatch(fetchStillage(filters)),
        dispatch(fetchRemakes(filters)),
        dispatch(fetchBacklog(filters)),
        dispatch(fetchBit(filters)),
        dispatch(fetchShelled(filters)),
        dispatch(fetchTotals(filters)),
        dispatch(fetchDisputes(filters)),
        dispatch(fetchOtherIssues(filters)),
    ];
    return {
        abort: () => {
            requests.forEach(req => {
                if (req && typeof req.abort === 'function') {
                    req.abort();
                }
            });
        }
    };
};